/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createPrebid } from '../fn/prebid/create-prebid';
import { CreatePrebid$Params } from '../fn/prebid/create-prebid';
import { findPrebids } from '../fn/prebid/find-prebids';
import { FindPrebids$Params } from '../fn/prebid/find-prebids';
import { FindPrebidsResponseDto } from '../models/find-prebids-response-dto';
import { patchPrebid } from '../fn/prebid/patch-prebid';
import { PatchPrebid$Params } from '../fn/prebid/patch-prebid';
import { PrebidDto } from '../models/prebid-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedPrebidService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findPrebids()` */
  static readonly FindPrebidsPath = '/api/prebids';

  /**
   * Finds prebids by a given filter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findPrebids()` instead.
   *
   * This method doesn't expect any request body.
   */
  findPrebids$Response(params: FindPrebids$Params, context?: HttpContext): Observable<StrictHttpResponse<FindPrebidsResponseDto>> {
    return findPrebids(this.http, this.rootUrl, params, context);
  }

  /**
   * Finds prebids by a given filter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findPrebids$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findPrebids(params: FindPrebids$Params, context?: HttpContext): Observable<FindPrebidsResponseDto> {
    return this.findPrebids$Response(params, context).pipe(
      map((r: StrictHttpResponse<FindPrebidsResponseDto>): FindPrebidsResponseDto => r.body)
    );
  }

  /** Path part for operation `createPrebid()` */
  static readonly CreatePrebidPath = '/api/prebids';

  /**
   * Creates a prebid.
   *
   * Creates a prebid for a given user, optionally creating a new bidder, if necessary.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPrebid()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPrebid$Response(params: CreatePrebid$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidDto>> {
    return createPrebid(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a prebid.
   *
   * Creates a prebid for a given user, optionally creating a new bidder, if necessary.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPrebid$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPrebid(params: CreatePrebid$Params, context?: HttpContext): Observable<PrebidDto> {
    return this.createPrebid$Response(params, context).pipe(
      map((r: StrictHttpResponse<PrebidDto>): PrebidDto => r.body)
    );
  }

  /** Path part for operation `patchPrebid()` */
  static readonly PatchPrebidPath = '/api/prebids/{id}';

  /**
   * Patches a prebid.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchPrebid()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchPrebid$Response(params: PatchPrebid$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidDto>> {
    return patchPrebid(this.http, this.rootUrl, params, context);
  }

  /**
   * Patches a prebid.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchPrebid$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchPrebid(params: PatchPrebid$Params, context?: HttpContext): Observable<PrebidDto> {
    return this.patchPrebid$Response(params, context).pipe(
      map((r: StrictHttpResponse<PrebidDto>): PrebidDto => r.body)
    );
  }

}
